<ng-template #dateTemplate>
  <span class="date-time" *ngIf="includeDate">{{ date | date: dateFormat:timeZone }}</span>
  <span *ngIf="hasDateValues">{{ separator }}</span>
  <span class="date-time" *ngIf="includeTime">{{ date | date: timeFormat:timeZone }}</span>
  <span class="date-time" *ngIf="!date" translate>{{ this.fallback }}</span>
</ng-template>
<ng-container *ngIf="relative; else dateTemplate">
  <span class="date-time">{{ date | relativeTime }}</span>
</ng-container>
